export default __webpack_public_path__ + "static/media/ok.6c5c6fb0.svg";